export default "__VITE_ASSET__e8ac503e__"